"use client";

import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";
import MailGray from "@/app/icons/mail-gray.svg";
import UserIcon from "@/app/icons/user.svg";

export default function PersonalInfo({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Personal Information</h2>
            <p className={styles.description}>Let&apos;s start with your basic details</p>

            <TextInput
                placeholder="Your Name"
                required
                icon={UserIcon}
                value={data.name}
                onChange={(e) => onChange('name', e.target.value)}
            />

            <TextInput
                type="email"
                placeholder="Email Address (Optional)"
                icon={MailGray}
                value={data.email}
                onChange={(e) => onChange('email', e.target.value)}
            />

            <TextInput
                type="phone"
                placeholder="Phone Number"
                required
                value={data.phone}
                onChange={(value) => onChange('phone', value)}
            />

            <p className={styles.note}>
                * Phone number is required so our team can reach you quickly
            </p>
        </div>
    )
}
